// api.js - Simpler version
const API_BASE = process.env.VUE_APP_API_URL || 'https://golang.roberms.com/api' ;

// 'http://localhost:5000/api' 'https://golang.roberms.com/api'

export function getAuthHeaders() {
  const token = localStorage.getItem("token");
  const headers = {};
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  return headers;
}

export async function apiFetch(url, options = {}) {
  const headers = { ...getAuthHeaders() };

  // Set Content-Type if not FormData
  if (!(options.body instanceof FormData)) {
    if (!options.headers || !options.headers['Content-Type']) {
      headers['Content-Type'] = 'application/json';
    }
  }

  // Merge headers
  if (options.headers) {
    Object.assign(headers, options.headers);
  }

  const response = await fetch(`${API_BASE}${url}`, {
    ...options,
    headers
  });

  // Handle auth
  if (response.status === 401) {
    localStorage.removeItem("token");
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }

  // ✅ Parse JSON ONCE
  const data = await response.json();

  // ✅ Fail only on HTTP error
  if (!response.ok) {
    throw new Error(data.message || "Request failed");
  }

  // ✅ Return parsed data
  return data;
}

// For file uploads specifically
export async function uploadFile(url, formData) {
  return apiFetch(url, {
    method: 'POST',
    body: formData
    // No Content-Type header - browser sets it automatically
  });
}